import { render, staticRenderFns } from "./Giro555.vue?vue&type=template&id=0ba1d464&scoped=true&"
import script from "./Giro555.vue?vue&type=script&lang=ts&"
export * from "./Giro555.vue?vue&type=script&lang=ts&"
import style0 from "./Giro555.vue?vue&type=style&index=0&id=0ba1d464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1d464",
  null
  
)

export default component.exports